export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] md:w-[800px] md:h-[800px] rounded-full bg-primary-100/40 blur-3xl -translate-y-1/3 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] md:w-[500px] md:h-[500px] rounded-full bg-accent-100/30 blur-3xl translate-y-1/3 -translate-x-1/4"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] rounded-full bg-secondary-100/20 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              每日更新 · 热播推荐
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight tracking-tight">
              糖心影视
              <span className="block text-primary-600">高清免费在线观影平台</span>
            </h1>

            <p className="mt-4 text-base md:text-lg text-foreground-600 font-medium">
              即点即播，甜蜜观影
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              糖心影视平台汇聚海量高清影视资源，覆盖最新院线大片、热播电视剧全集、人气综艺与经典动漫。
              无需注册、无需下载，打开糖心影视网站即可畅享流畅不卡顿的观影体验。
              每日持续更新，紧跟全网热点，让每一次观影都成为甜蜜的享受。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600">10万+</p>
                <p className="text-xs text-foreground-500 mt-1">影视资源</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">每日更新</p>
                <p className="text-xs text-foreground-500 mt-1">实时同步</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">高清流畅</p>
                <p className="text-xs text-foreground-500 mt-1">极速播放</p>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                开始观影
                <i className="ri-arrow-right-line ml-2 align-middle"></i>
              </a>
              <a
                href="#carousel"
                onClick={(e) => handleNavClick(e, '#carousel')}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-700 border border-background-300/60 rounded-lg hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                精选专题
                <i className="ri-arrow-down-line ml-2 align-middle"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[460px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20composition%20with%20warm%20ambient%20lighting%20featuring%20abstract%20film%20reels%20and%20projector%20lens%20flares%20in%20soft%20coral%20and%20gold%20tones%2C%20floating%20geometric%20shapes%20suggesting%20movie%20screens%2C%20elegant%20minimal%20design%20with%20dark%20cinematic%20accents%2C%20artistic%20and%20atmospheric%20mood%2C%20no%20text%20no%20people&width=920&height=690&seq=hero-visual-001&orientation=landscape"
                alt="糖心影视平台高清观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10"></div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/60 via-background-950/20 to-transparent p-6">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm">
                    <i className="ri-play-fill text-background-50 text-xl"></i>
                  </span>
                  <span className="text-background-50 text-sm font-medium">海量高清 · 即点即播</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}